import {idpPath, IDP} from '@ctsu/loader';
import { ProtocolsContainer } from 'containers/protocol';
import { ProtocolBrowser } from 'containers/protocolbrowser';
import { Protocol } from 'appconstants/ProtocolConstants';
import ProtocolInfoContainer from 'containers/protocol/protocoldetail';
import ParticipationContainer from 'containers/protocol/participation';
import VersionsContainer from 'containers/protocol/versions';
import StudyAgentContainer from 'containers/protocol/studyagent';
import PSRSContainer from 'containers/protocol/psrs';
import CirbsContainer from 'containers/protocol/cirb';
import OpenContainer from 'containers/protocol/opensetup';
import IntegrationsContainer from 'containers/protocol/integrations';
import FundingContainer from 'containers/protocol/funding';
import AdministrationContainer from 'containers/protocol/administration';
import { NoMatch } from 'components';
import protcolSetupRoutes from 'protocol-setup/routes';
import { Login, protect, LogOut } from 'components/Layout/Login';
import NoAccess from 'acess/NoAcces';




export const protocolBaseRoutes = [
  {
    path: '/',
    name: 'Browser',
    shortName: 'Browser',
    isExact: true,
    permission: 'protocol.info',
    component: protect(ProtocolBrowser),
    showInMenu: true
  },
  {
    path: '/protocol',
    isExact: false,
    name: 'Protocol',
    shortName: 'Protocol',
    permission: 'protocol.info',
    component: protect(ProtocolsContainer),
    showInMenu: true
  },

  {
    path: idpPath,
    name: 'IDP',
    shortName: 'IDP Page',
    isExact: true,
    component: IDP,
    showInMenu: false
  },
  {
    path: '/noaccess',
    name: 'No Access',
    shortName: 'No Access',
    isExact: true,
    component: NoAccess,
    showInMenu: false
  },

  {
    path: '/*',
    isExact: false,
    component: NoMatch,
    name: 'NONE',
    showInMenu: false
  }

];

export const indexRoutes = [
  {
    path: '/logout', isExact: true, name: 'Logout', component: LogOut,
    showInMenu: false
  },
  {
    path: '/login', isExact: true, name: 'Protocol Login', component: Login,
    showInMenu: false
  },
  ...protcolSetupRoutes,
  ...protocolBaseRoutes
];

export const protocolRoutes = [
  {
    path: `/${Protocol.protocoldetail.id}`,
    name: Protocol.protocoldetail.shortname,
    component: ProtocolInfoContainer,
    icon: Protocol.protocoldetail.icon,
    permission: 'protocol.info'
  },
  {
    path: `/${Protocol.participation.id}`,
    name: Protocol.participation.title,
    component: ParticipationContainer,
    icon: Protocol.participation.icon,
    permission: 'protocol.participation'
  },
  {
    path: `/${Protocol.versions.id}`,
    name: Protocol.versions.title,
    component: VersionsContainer,
    icon: Protocol.versions.icon,
    permission: 'protocol.versions'
  },
  {
    path: `/${Protocol.studyagent.id}`,
    name: Protocol.studyagent.title,
    component: StudyAgentContainer,
    icon: Protocol.studyagent.icon,
    permission: 'protocol.agents'
  },
  {
    path: `/${Protocol.psrs.id}`,
    name: Protocol.psrs.shortname,
    component: PSRSContainer,
    icon: Protocol.psrs.icon,
    permission: 'protocol.psr'
  },
  {
    path: `/${Protocol.cirb.id}`,
    name: Protocol.cirb.title,
    component: CirbsContainer,
    icon: Protocol.cirb.icon,
    permission: 'protocol.cirb'
  },
  {
    path: `/${Protocol.opensetup.id}`,
    name: Protocol.opensetup.title,
    component: OpenContainer,
    icon: Protocol.opensetup.icon,
    permission: 'protocol.open.setup'
  },
  {
    path: `/${Protocol.integrations.id}`,
    name: Protocol.integrations.title,
    component: IntegrationsContainer,
    icon: Protocol.integrations.icon,
    permission: 'protocol.integrations'
  },
  {
    path: `/${Protocol.funding.id}`,
    name: Protocol.funding.title,
    component: FundingContainer,
    icon: Protocol.funding.icon,
    permission: 'protocol.funding.details'
  },
  /*
    RSSMOD-906: https://jira.westat.com/browse/RSSMOD-906
  */
  {
    path: `/${Protocol.admin.id}`,
    name: Protocol.admin.title,
    component: AdministrationContainer,
    icon: Protocol.admin.icon,
    permission: 'protocol.admin'
  }

];

export default indexRoutes;
